import { useTranslation } from "react-i18next";
import { RewardsSectionProps } from "../types";
import { formatMonetaryAmount } from "@/utils/numbers.utils";
import { InfoSection, InfoRow } from "@/components/ui/data-display";
import { CurrencyAmount } from "@/components/ui/CurrencyAmount";

interface RewardsSectionExtendedProps extends RewardsSectionProps {
  isSuccess?: boolean;
}

export function RewardsSection({ creditBackEarned, currency, isSuccess = false }: RewardsSectionExtendedProps) {
  const { t } = useTranslation();

  const bgClass = isSuccess
    ? "bg-[#f0f9f0] border border-[#d0e8d0]"
    : "bg-[#ffffff] border border-[#ff735b]";

  const label = isSuccess
    ? t("payment.cashbackEarned")
    : t("payment.cashbackYouWillEarn");

  return (
    <InfoSection 
      title={t("payment.rewards")}
      className={`${bgClass} rounded-lg p-4 space-y-2`}
      titleClassName="text-black-800"
      tooltip={t("payment.rewardsTooltip")}
    >
      <InfoRow 
        label={label}
        value={
          <CurrencyAmount
            amount={formatMonetaryAmount(creditBackEarned)}
            currency={currency}
          />
        }
        isNumeric
      />
    </InfoSection>
  );
} 